module.exports = __webpack_public_path__ + "media/images/shop/photo_large3-aafb8e303851e212c8ae414f3153a5f8.jpg";